import {ThunkActionCreator} from "../interfaces/thunk";
import {Dispatch} from "../interfaces/dispatch";
import axios from "axios";
import Config from "../config";
import {getHeaders} from "../helpers/headers";
import {AnyAction} from "../interfaces/action";
import {handleActions} from "redux-actions";
import {SeverityLevel, ToastService} from "../services/toastService";
import {SAVE_USER_FAILED} from "./users";



const FETCH_CHAINS_USER_REQUEST = "FETCH_CHAINS_USER_REQUEST";
const FETCH_CHAIN_USERS = "FETCH_CHAIN_USERS";
const FETCH_CHAIN_USERS_FAILED ="FETCH_CHAIN_USERS_FAILED"
const FETCH_USER_STORE_MAPPING_REQUEST = "FETCH_USER_STORE_MAPPING_REQUEST"
const FETCH_USER_STORE_MAPPING = "FETCH_USER_STORE_MAPPING"
const FETCH_USER_STORE_MAPPING_FAILED = "FETCH_USER_STORE_MAPPING"

const FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST";
const FETCH_ROLES = "FETCH_ROLES";
const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";

const UPDATE_CHAIN_USER_ROLE_REQUEST="UPDATE_CHAIN_USER_ROLE"
const UPDATE_CHAIN_USER_ROLE ="UPDATE_CHAIN_USER_ROLE"
const UPDATE_CHAIN_USER_ROLE_FAILURE= "UPDATE_CHAIN_USER_ROLE_FAILURE"

const DELETE_CHAIN_USER_ROLE_MAPPING_REQUEST="DELETE_CHAIN_USER_ROLE_MAPPING_REQUEST"
const DELETE_CHAIN_USER_ROLE_MAPPING="DELETE_CHAIN_USER_ROLE_MAPPING"
const DELETE_CHAIN_USER_ROLE_MAPPING_FAILURE="DELETE_CHAIN_USER_ROLE_MAPPING_FAILURE"

const UPDATE_USER_STORE_REQUEST = "UPDATE_USER_STORE_REQUEST"
const UPDATE_USER_STORE = "UPDATE_USER_STORE"
const UPDATE_USER_STORE_FAILURE = "UPDATE_USER_STORE_FAILURE"

const FETCH_CHAIN_USER_ROLE_MAPPING_REQUEST = "FETCH_CHAIN_USER_ROLE_MAPPING_REQUEST"
const FETCH_CHAIN_USER_ROLE_MAPPING = "FETCH_CHAIN_USER_ROLE_MAPPING"
const FETCH_CHAIN_USER_ROLE_MAPPING_FAILED = "FETCH_CHAIN_USER_ROLE_MAPPING_FAILED"
//USER2STORE
const FETCH_USERS_TO_STORES_REQUEST = "FETCH_USERS_TO_STORES_REQUEST";
const EXPORT_USERS_TO_STORES = "EXPORT_USERS_TO_STORES";
const FETCH_USERS_TO_STORES_FAILED = "FETCH_USERS_TO_STORES_FAILED";
const DELETE_USERS_TO_STORES_REQUEST = "DELETE_USERS_TO_STORES_REQUEST";
const DELETE_USERS_TO_STORES = "DELETE_USERS_TO_STORES";
const DELETE_USERS_TO_STORES_FAILED = "DELETE_USERS_TO_STORES_FAILED";
const DELETE_ALL_USERS_TO_STORES_REQUEST = "DELETE_ALL_USERS_TO_STORES_REQUEST";
const DELETE_ALL_USERS_TO_STORES = "DELETE_ALL_USERS_TO_STORES";
const DELETE_ALL_USERS_TO_STORES_FAILED = "DELETE_ALL_USERS_TO_STORES_FAILED";
const DELETE_USER_TO_CHAIN_REQUEST = "DELETE_USER_TO_CHAIN_REQUEST";
const DELETE_USER_TO_CHAIN = "DELETE_USER_TO_CHAIN";
const DELETE_USER_TO_CHAIN_FAILED = "DELETE_USER_TO_CHAIN_FAILED";

const DELETE_STORES_TO_USER_REQUEST = "DELETE_STORES_TO_USER_REQUEST";
const DELETE_STORES_TO_USER = "DELETE_STORES_TO_USER";
const DELETE_STORES_TO_USER_FAILED = "DELETE_STORES_TO_USER_FAILED";

const DELETE_ALL_CHAIN_USER_ROLES_REQUEST="DELETE_ALL_CHAIN_USER_ROLES_REQUEST"
const DELETE_ALL_CHAIN_USER_ROLES="DELETE_ALL_CHAIN_USER_ROLES"
const DELETE_ALL_CHAIN_USER_ROLES_FAILED="DELETE_ALL_CHAIN_USER_ROLES_FAILED"

const FETCH_COPY_STORE_USER_REQUEST = "FETCH_COPY_STORE_USER_REQUEST"
const FETCH_COPY_STORE_USER = "FETCH_COPY_STORE_USER"
const FETCH_COPY_STORE_USER_FAILED = "FETCH_COPY_STORE_USER_FAILED"

const CREATE_CHAIN_USER_ROLE_REQUEST = "FETCH_COPY_USER_INFO_REQUEST"
const CREATE_CHAIN_USER_ROLE = "FETCH_COPY_USER_INFO"
const CREATE_CHAIN_USER_ROLE_FAILED = "FETCH_COPY_USER_INFO_FAILED"

const CREATE_STORE_CHAIN_USER_REQUEST ="CREATE_STORE_CHAIN_USER_REQUEST"
const CREATE_STORE_CHAIN_USER ="CREATE_STORE_CHAIN_USER"
const CREATE_STORE_CHAIN_USER_FAILED ="CREATE_STORE_CHAIN_USER_FAILED"

export {
  FETCH_CHAINS_USER_REQUEST,
  FETCH_USER_STORE_MAPPING_REQUEST,
  FETCH_USER_STORE_MAPPING,
  FETCH_USER_STORE_MAPPING_FAILED,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES,
  FETCH_ROLES_FAILURE,
  UPDATE_CHAIN_USER_ROLE_REQUEST,
  UPDATE_CHAIN_USER_ROLE,
  UPDATE_CHAIN_USER_ROLE_FAILURE,
  DELETE_CHAIN_USER_ROLE_MAPPING_REQUEST,
  DELETE_CHAIN_USER_ROLE_MAPPING,
  DELETE_CHAIN_USER_ROLE_MAPPING_FAILURE,
  UPDATE_USER_STORE_REQUEST,
  UPDATE_USER_STORE,
  UPDATE_USER_STORE_FAILURE,
  FETCH_CHAIN_USER_ROLE_MAPPING_REQUEST,
  FETCH_CHAIN_USER_ROLE_MAPPING,
  FETCH_CHAIN_USER_ROLE_MAPPING_FAILED,
  FETCH_COPY_STORE_USER_REQUEST,
  FETCH_COPY_STORE_USER,
  FETCH_COPY_STORE_USER_FAILED,
  CREATE_CHAIN_USER_ROLE_REQUEST,
  CREATE_CHAIN_USER_ROLE,
  CREATE_CHAIN_USER_ROLE_FAILED,
  FETCH_CHAIN_USERS,
  FETCH_CHAIN_USERS_FAILED,
  FETCH_USERS_TO_STORES_REQUEST,
  EXPORT_USERS_TO_STORES,
  FETCH_USERS_TO_STORES_FAILED,
  DELETE_USERS_TO_STORES_REQUEST,
  DELETE_USERS_TO_STORES,
  DELETE_USERS_TO_STORES_FAILED,
  DELETE_ALL_USERS_TO_STORES_REQUEST,
  DELETE_ALL_USERS_TO_STORES,
  DELETE_ALL_USERS_TO_STORES_FAILED,
  DELETE_USER_TO_CHAIN_REQUEST,
  DELETE_USER_TO_CHAIN,
  DELETE_USER_TO_CHAIN_FAILED,

  DELETE_STORES_TO_USER_REQUEST,
  DELETE_STORES_TO_USER,
  DELETE_STORES_TO_USER_FAILED,

  DELETE_ALL_CHAIN_USER_ROLES_REQUEST,
  DELETE_ALL_CHAIN_USER_ROLES,
  DELETE_ALL_CHAIN_USER_ROLES_FAILED,

  CREATE_STORE_CHAIN_USER_REQUEST,
  CREATE_STORE_CHAIN_USER,
  CREATE_STORE_CHAIN_USER_FAILED
}
export const fetchChainUsers: ThunkActionCreator<Promise<void>> =
  (queryParams?: Record<string, any>) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_CHAINS_USER_REQUEST });
    let url = `${Config.API_SERVICE_URL}/api/chain-user-role`;
    if (queryParams) {
      const qs = new URLSearchParams();
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          qs.append(key, String(value));
        }
      });
      url += `?${qs.toString()}`;
    }
    return axios
      .get(url, getHeaders())
      .then((response) => {
        dispatch({ type: FETCH_CHAIN_USERS, payload: response?.data });
      })
      .catch(() => {
        dispatch({ type: FETCH_CHAIN_USERS_FAILED });
      });
  };

export const fetchManageDataAccess: ThunkActionCreator<Promise<boolean>> =
  (userId: number) => (_dispatch: Dispatch) => {
    const url = `${Config.API_SERVICE_URL}/api/logged-user-chains/manage-data-access/${userId}`;
    return axios
      .get(url, getHeaders())
      .then((response) => Boolean(response?.data?.hasManageDataAccess))
      .catch(() => false);
  };


export const updateUserChainRoleMapping: ThunkActionCreator<Promise<void>> = (updateChainUserRole) => (dispatch: Dispatch) => {
  dispatch({ type: UPDATE_CHAIN_USER_ROLE_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/getRoles/update-role`;
  return axios
    .post(url,updateChainUserRole, getHeaders())
    .then((response) => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "User Chain Role updated successfully!",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      dispatch({ type: UPDATE_CHAIN_USER_ROLE, payload: response.data });
    })
    .catch(() => {
      dispatch({ type: UPDATE_CHAIN_USER_ROLE_FAILURE });
    });
}

export const deleteChainUserRoleMapping: ThunkActionCreator<Promise<void>> = (mapingId:number) => (dispatch: Dispatch) => {
  dispatch({ type: DELETE_CHAIN_USER_ROLE_MAPPING_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/chain-user-role/delete-mapping?mappingId=${mapingId}`;
  return axios
    .get(url, getHeaders())
    .then((response) => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "User Chain Role deleted successfully!",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      dispatch({ type: DELETE_CHAIN_USER_ROLE_MAPPING, payload: response.data });
    })
    .catch(() => {
      dispatch({ type: DELETE_CHAIN_USER_ROLE_MAPPING_FAILURE });
    });

}

export const updateUserStoreMapping: ThunkActionCreator<Promise<void>> = (updateUserStore) => (dispatch: Dispatch) => {
  dispatch({ type: UPDATE_USER_STORE_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/users-stores/addUserChain`;
  return axios
    .post(url,updateUserStore, getHeaders())
    .then((response) => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "Store access to the user granted successfully!",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      dispatch({ type: UPDATE_USER_STORE, payload: response.data });
    })
    .catch(() => {
      dispatch({ type: UPDATE_USER_STORE_FAILURE });
    });
}

export const deleteAllChainRoleMappings: ThunkActionCreator<Promise<void>> = (updateUserStore) => (dispatch: Dispatch) => {
  dispatch({ type: DELETE_ALL_CHAIN_USER_ROLES_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/chain-user-role/deleteAllUserChainRoles`;
  return axios
    .post(url,updateUserStore, getHeaders())
    .then((response) => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "All user chain role mapping deleted successfully! ",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      dispatch({ type: DELETE_ALL_CHAIN_USER_ROLES, payload: response.data });
    })
    .catch(() => {
      dispatch({ type: DELETE_ALL_CHAIN_USER_ROLES_FAILED });
    });
}


export const exportUsersStoresMapping: ThunkActionCreator<Promise<void>> = (chainId:number) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_USER_STORE_MAPPING_REQUEST });
    let url = `${Config.API_SERVICE_URL}/api/export-user-stores/${chainId}`;
    return axios
      .get(url, getHeaders())
      .then((response) => {
        dispatch({ type: FETCH_USER_STORE_MAPPING, payload: response.data });
      })
      .catch(() => {
        dispatch({ type: FETCH_USER_STORE_MAPPING_FAILED });
      });
  };

export const exportAllUserChainMapping: ThunkActionCreator<Promise<void>> = (chainId:number) =>(dispatch: Dispatch) =>{
  dispatch({ type: FETCH_CHAIN_USER_ROLE_MAPPING_REQUEST });
   let url = `${Config.API_SERVICE_URL}/api/export-chain-user-role/${chainId}`;
  return axios
    .get(url, getHeaders())
    .then((response) => {
      dispatch({ type: FETCH_CHAIN_USER_ROLE_MAPPING, payload: response.data });
    })
    .catch(() => {
      dispatch({ type: FETCH_CHAIN_USER_ROLE_MAPPING_FAILED });
    });
}



export const exportUsersToStoresByChainId: ThunkActionCreator<Promise<void>> =
  (chainId: number, queryParams?: { email: string }) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_USERS_TO_STORES_REQUEST });
    let url = `${Config.API_SERVICE_URL}/api/users-stores?chainId=${chainId}`;
    if (queryParams) {
      url += `&email=${queryParams.email}`;
    }
    return axios
      .get(url, getHeaders())
      .then((response) => {
        dispatch({ type: EXPORT_USERS_TO_STORES, payload: response.data });
      })
      .catch(() => {
        dispatch({ type: FETCH_USERS_TO_STORES_FAILED });
      });
  };

export const deleteUserToStore: ThunkActionCreator<Promise<void>> =
  (id) => (dispatch: Dispatch) => {
    dispatch({ type: DELETE_USERS_TO_STORES_REQUEST });
    return axios
      .delete(`${Config.API_SERVICE_URL}/api/users-stores/${id}`, getHeaders())
      .then((_) => {
        dispatch({ type: DELETE_USERS_TO_STORES, payload: { id } });
      })
      .catch((error: Error) => {
        dispatch({ type: DELETE_USERS_TO_STORES_FAILED });
      });
  };

export const deleteUserToChainStoreMappings: ThunkActionCreator<Promise<void>> =
  (userId, chainId) => (dispatch: Dispatch) => {
    dispatch({ type: DELETE_USER_TO_CHAIN_REQUEST });
    return axios
      .delete(`${Config.API_SERVICE_URL}/api/users/${userId}/user-stores/${chainId}`, getHeaders())
      .then(() => {
        dispatch({ type: DELETE_USER_TO_CHAIN, payload: { userId, chainId } });
      })
      .catch((error: Error) => {
        dispatch({ type: DELETE_USER_TO_CHAIN_FAILED });
      });
  };

export const deleteAllUserToStoreMappings: ThunkActionCreator<Promise<void>> =
  (userId) => (dispatch: Dispatch) => {
    dispatch({ type: DELETE_ALL_USERS_TO_STORES_REQUEST });
    return axios
      .delete(`${Config.API_SERVICE_URL}/api/users/${userId}/user-stores`, getHeaders())
      .then(() => {
        ToastService.getInstance().publishToast(
          {
            identifier: "success-operation",
            title: "Success",
            message: "User store access revoked successfully!",
          },
          SeverityLevel.SUCCESS,
          { autoClose: 3000 }
        );
        dispatch({ type: DELETE_ALL_USERS_TO_STORES, payload: { userId } });
      })
      .catch((error: Error) => {
        dispatch({ type: DELETE_ALL_USERS_TO_STORES_FAILED });
      });
  };

export const getRoles: ThunkActionCreator<Promise<void>> = () => (dispatch: Dispatch) => {
  dispatch({ type: FETCH_ROLES_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/getRoles`;
  return axios
    .get(url, getHeaders())
    .then((response) => {
      dispatch({ type: FETCH_ROLES, payload: response.data });
    })
    .catch(() => {
      dispatch({ type: FETCH_ROLES_FAILURE });
    });
}

export const deleteStoresToUser: ThunkActionCreator<Promise<void>> =
  (data: number[], userId: number) => (dispatch: Dispatch) => {
    dispatch({ type: DELETE_STORES_TO_USER_REQUEST });
    return axios
      .post(`${Config.API_SERVICE_URL}/api/users/delete-user-stores`, { stores: data, userId }, getHeaders())
      .then((response) => {
        dispatch({ type: DELETE_STORES_TO_USER, payload: response.data });
      })
      .catch((error: Error) => {
        dispatch({ type: DELETE_STORES_TO_USER_FAILED });
      });
  };


export const copyStoreUserMapping: ThunkActionCreator<Promise<void>> = (copyStoreUser) => (dispatch: Dispatch) => {
  dispatch({ type: FETCH_COPY_STORE_USER_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/chain-user-role/copy-chain-user-stores`;
  return axios
    .post(url,copyStoreUser, getHeaders())
    .then((response) => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "Copied Source Users Chains Stores to Target Users successfully!",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      dispatch({ type: FETCH_COPY_STORE_USER, payload: response.data });
    })
    .catch((e) => {
       console.log("Test of error",e?.response?.data?.errors)
      dispatch({ type: FETCH_COPY_STORE_USER_FAILED,payload:e?.response?.data?.errors });
    });
}

export const saveChainUserRoleFrom: ThunkActionCreator<Promise<void>> = (userDetails) => (dispatch: Dispatch) => {
  dispatch({ type: CREATE_CHAIN_USER_ROLE_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/chain-user-role/create-chain-user-mapping`;
  return axios
    .post(url,userDetails, getHeaders())
    .then((response) => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "User created successfully!",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      dispatch({ type: CREATE_CHAIN_USER_ROLE, payload: response.data });
    })
    .catch((e) => {
      dispatch({ type: CREATE_CHAIN_USER_ROLE_FAILED ,payload:e.response.data.error});
    });
}

export const saveStoreChainUserRole: ThunkActionCreator<Promise<void>> = (userDetails) => (dispatch: Dispatch) => {
  dispatch({ type: CREATE_STORE_CHAIN_USER_REQUEST });
  let url = `${Config.API_SERVICE_URL}/api/users-stores/add-store-user-chain`;
  return axios
    .post(url,userDetails, getHeaders())
    .then((response) => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "User created successfully!",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      dispatch({ type: CREATE_STORE_CHAIN_USER, payload: response.data });
    })
    .catch((e) => {
      dispatch({ type: CREATE_STORE_CHAIN_USER_FAILED ,payload:e.response?.data?.errors});
    });
}

const actions = {
  [FETCH_CHAINS_USER_REQUEST]: (state: ChainUserState) => ({
    ...state,
    chainRoleLoader: true,
  }),
  [FETCH_CHAIN_USERS]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    chainRoleLoader: false,
    content: action.payload.data,
    totalPages: action.payload.totalPages,
    totalCount:action.payload.totalCount,
    pageSize: action.payload.pageSize,
    currentPage:  action.payload.currentPage
  }),
  [FETCH_CHAIN_USERS_FAILED]: (state: ChainUserState): ChainUserState => ({
    ...state,
    chainRoleLoader: false,
    error: true,
    content: [],
  }),
  [FETCH_USER_STORE_MAPPING]:(state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    exportChainUserContent:action.payload,
  }),
  [FETCH_ROLES_REQUEST]: (state: ChainUserState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_ROLES]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    roles: action.payload,
  }),
  [FETCH_ROLES_FAILURE]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
    roles: [],
  }),
  [UPDATE_CHAIN_USER_ROLE_REQUEST]: (state: ChainUserState) => ({
    ...state,
    loading: true,
  }),
  [UPDATE_CHAIN_USER_ROLE]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    roleUpdated: !!action.payload,
  }),
  [UPDATE_CHAIN_USER_ROLE_FAILURE]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
    roleUpdated: false,
  }),

  [DELETE_CHAIN_USER_ROLE_MAPPING_REQUEST]: (state: ChainUserState) => ({
    ...state,
    loading: true,
  }),
  [DELETE_CHAIN_USER_ROLE_MAPPING]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    mappingDeleted: !!action.payload,
  }),
  [DELETE_CHAIN_USER_ROLE_MAPPING_FAILURE]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
    mappingDeleted: false,
  }),


  [UPDATE_USER_STORE_REQUEST]: (state: ChainUserState) => ({
    ...state,
    loading: true,
  }),
  [UPDATE_USER_STORE]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    userStoreUpdated: !!action.payload,
  }),
  [UPDATE_USER_STORE_FAILURE]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
    userStoreUpdated: false,
  }),


  [FETCH_CHAIN_USER_ROLE_MAPPING_REQUEST]: (state: ChainUserState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_CHAIN_USER_ROLE_MAPPING]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    exportChainUserRoleContent: action.payload,
  }),
  [FETCH_CHAIN_USER_ROLE_MAPPING_FAILED]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
    exportChainUserRoleContent: [],
  }),



  [DELETE_STORES_TO_USER_REQUEST]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: true,
  }),
  [DELETE_STORES_TO_USER]: (state: ChainUserState, action: AnyAction): ChainUserState => {
    // instead of re-fetching all user2store entries after deleting a single one, filter out deleted id from previously fetched entries
    return {
      ...state,
      loading: false,
      content: state.content,
    };
  },
  [DELETE_STORES_TO_USER_FAILED]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
  }),

//Old code changes
  [EXPORT_USERS_TO_STORES]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    exportContent: [...action.payload.mappings],
  }),
  [DELETE_USERS_TO_STORES_REQUEST]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: true,
  }),
  [DELETE_USERS_TO_STORES]: (state: ChainUserState, action: AnyAction): ChainUserState => {
    const id = action.payload.id.toString();
    // instead of re-fetching all user2store entries after deleting a single one, filter out deleted id from previously fetched entries
    return {
      ...state,
      loading: false,
      content: (state.content || []).filter((c) => c.id.toString() !== id),
    };
  },
  [DELETE_USERS_TO_STORES_FAILED]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
  }),
  [DELETE_ALL_USERS_TO_STORES_REQUEST]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: true,
  }),
  [DELETE_ALL_USERS_TO_STORES]: (
    state: ChainUserState,
    action: AnyAction
  ): ChainUserState => {
    const userId = action.payload.userId.toString();

    // instead of re-fetching all user2store entries after deleting a single one, filter out deleted id from previously fetched entries
    return {
      ...state,
      loading: false,
      content: (state.content || []).filter((c) => c.user_id.toString() !== userId),
    };
  },
  [DELETE_ALL_USERS_TO_STORES_FAILED]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
  }),
  [DELETE_USER_TO_CHAIN_REQUEST]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: true,
    error: false,
  }),
  [DELETE_USER_TO_CHAIN]: (state: ChainUserState, action: AnyAction): ChainUserState => {
    const userId = action.payload.userId.toString();
    const chainId = action.payload.chainId.toString();

    // instead of re-fetching all user2store entries after deleting a single one, filter out deleted id from previously fetched entries
    return {
      ...state,
      loading: false,
      error: false,
      content: (state.content || []).filter(
        (c) => c.chain_id.toString() !== chainId || c.user_id.toString() !== userId
      ),
    };
  },
  [DELETE_USER_TO_CHAIN_FAILED]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
  }),


  [DELETE_ALL_CHAIN_USER_ROLES_REQUEST]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: true,
    error: false,
  }),
  [DELETE_ALL_CHAIN_USER_ROLES]: (state: ChainUserState, action: AnyAction): ChainUserState => {
    return {
      ...state,
      loading: false,
      error: false,
    };
  },
  [DELETE_ALL_CHAIN_USER_ROLES_FAILED]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
  }),


  [FETCH_COPY_STORE_USER_REQUEST]: (state: ChainUserState): ChainUserState => ({
    ...state,
    loading: true,
    error: false,
  }),
  [FETCH_COPY_STORE_USER]: (state: ChainUserState, action: AnyAction): ChainUserState => {
    return {
      ...state,
      loading: false,
      error: false,
    };
  },
  [FETCH_COPY_STORE_USER_FAILED]: (state: ChainUserState,action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
    errorCopyUserAssignMessage:action.payload
  }),
  [CREATE_CHAIN_USER_ROLE_REQUEST]: (state: ChainUserState) => ({
  ...state,
  loading: true,
}),
  [CREATE_CHAIN_USER_ROLE]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
  ...state,
  loading: false,
    saveChainUserRoleFormReq: action.payload,
    saveChainUserErrorMessage:""
}),
  [CREATE_CHAIN_USER_ROLE_FAILED]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
  ...state,
  loading: false,
  error: true,
    saveChainUserRoleFormReq: undefined,
    saveChainUserErrorMessage:action.payload
}),


  [CREATE_STORE_CHAIN_USER_REQUEST]: (state: ChainUserState) => ({
    ...state,
    loading: true,
  }),
  [CREATE_STORE_CHAIN_USER]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    saveChainUserErrorMessage:""
  }),
  [CREATE_STORE_CHAIN_USER_FAILED]: (state: ChainUserState, action: AnyAction): ChainUserState => ({
    ...state,
    loading: false,
    error: true,
    saveStoreUserError:action.payload
  }),

}


export interface Role {
  id: number;
  role: string;
}
// Initial State
export interface ChainUserState {
  error?: boolean;
  loading?: boolean;
  content?: ChainUserRole[];
  exportContent?: ChainUserRole[];
  exportChainUserContent?:UserStore[];
  exportChainUserRoleContent:UserChainRole[];
  roles:Role[];
  pageCount?: number;
  totalPages ?: number
  pageSize?: number
  totalCount?:number
  currentPage?: number
  roleUpdated:boolean,
  mappingDeleted:boolean
  userStoreUpdated:boolean;
  chainRoleLoader:boolean
  copyUserAssign:CopyUserAssign
  errorCopyUserAssignMessage:[]
  saveChainUserErrorMessage:string
  saveChainUserRoleFormReq:any
  saveStoreUserError:[]
}

export interface UserStore{
  readonly id:number;
  readonly chain_id:number
  readonly first_name:string
  readonly last_name:string
  readonly store_name:string
  readonly retail_store_num:any
  readonly state:string
  readonly chain_name:string
  readonly chain_parent_name:string
}


export interface UserChainRole{
  readonly parent_chain_name:string
  readonly first_name:string;
  readonly last_name:string;
  readonly email: string;
  readonly company:string;
  readonly role_name:string;
  readonly chain_name:string;
}

export interface ChainUserRole {
  readonly id: number;
  readonly chain_id: number;
  readonly user_id:number
  readonly email: string;
  readonly chainName: string;
  readonly  firstName:string;
  readonly chain_parent_name:string;
  readonly chain_parent_id:number;
  readonly lastName:string;
  readonly stores:[];
  readonly role:string
  readonly company:string;
  readonly chain_user_role_id:number
  readonly chainRoleLoader:boolean
}

export interface CopyUserAssign{
  readonly user_id:number |null
  readonly email: string;
  readonly  firstName:string;
  readonly  lastName:string;
}
const defaultCopyUserAssign: CopyUserAssign= {
  user_id:null,
  email:"",
  firstName:"",
  lastName:"",
}

const initialState: ChainUserState = {
  loading: false,
  error: false,
  content: [],
  exportContent: [],
  exportChainUserContent:[],
  exportChainUserRoleContent:[],
  totalPages: 1,
  pageSize:1,
  currentPage:1,
  totalCount:1,
  roles:[],
  roleUpdated:false,
  mappingDeleted:false,
  userStoreUpdated:false,
  chainRoleLoader:false,
  copyUserAssign:defaultCopyUserAssign,
  errorCopyUserAssignMessage:[],
  saveChainUserErrorMessage:"",
  saveChainUserRoleFormReq:undefined,
  saveStoreUserError:[]
};
// reducer
export default handleActions<ChainUserState, AnyAction>(actions, initialState);
